import { Component, Vue } from 'vue-property-decorator';
import { partnersAPI } from '@/providers/apis/partners/partners';
import { CountryModel } from '@/models/partners/country';
import { PartnerModel } from '@/models/partners/partner';
import McIcon from '@/components/icons/mc-icon/mc-icon';
import { numberFormatWithTextSuffix } from '@/helpers/number-format';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import FontAwesomeIcon from '@/components/icons/font-awesome-icon/font-awesome-icon';
import { PARTNERS_TYPE } from '@/utils/constants';
import axios from 'axios';
import { sortByProperty } from '@/utils/utils';
import { statsAPI } from '@/providers/apis/stats/stats';

@Component({
    name: 'partners-type',
    components: {
        'google-material-icon': GoogleMaterialIcon,
        'font-awesome-icon': FontAwesomeIcon,
        'mc-icon': McIcon,
    },
})
export default class PartnersType extends Vue {

    // -------------------------------------------------------------------------
    // Properties

    /**
     * Maintains partner type meta data values
     */
    private partnerType: {
        labelKey: string,
        type: string} = { labelKey: '', type: '' };

    /**
     * Maintains  the list of partners associated with the partner type.
     */
    private partners: PartnerModel[] = new Array();

    private get isCourseCount() {
        const keys = ['tools_providers', 'content_developers'];
        return keys.indexOf(this.partnerType.type) !== -1;
    }

    private get isUsersCounts() {
        const keys = ['implementation_partners', 'integration_partners', 'schools', 'lab_schools'];
        return keys.indexOf(this.partnerType.type) !== -1;
    }

    // -------------------------------------------------------------------------
    // Actions

    private back() {
        this.$router.back();
    }

    /**
     * Change Route to partner profile page
     */

    private onPreviewPartnerDetails(partnerId: number) {
        const path = `/collaborators/${partnerId}`;
        this.$router.push(path);
    }


    // -------------------------------------------------------------------------
    // Hooks

    private mounted() {
        this.initializeData();
    }

    // -------------------------------------------------------------------------
    // Methods

    private initializeData() {
        const partnerType = this.$route.params.type;
        const partnerTypeData = PARTNERS_TYPE.find((type) => (type.pathname === partnerType));
        if (partnerTypeData) {
            this.partnerType.labelKey = partnerTypeData.labelKey;
            this.partnerType.type = partnerTypeData.type;
            const type = partnerTypeData.type;
            statsAPI.getCountries().then((statsCountries) => {
                partnersAPI.getPartnersByType(partnerTypeData.type).then((partners) => {
                        partners.forEach((partner: PartnerModel) => {
                             if (type === 'researchers' || type === 'funders') {
                            const countryData  = partner.countries[0] ? partner.countries[0] : null;
                            const countryCode = countryData ?  countryData.code : '';
                            const countryStats = statsCountries.find((country: any) =>
                                (countryCode === country.country_code));
                            if (countryStats) {
                                partner.total_users = countryStats.total_users;
                                partner.total_teachers = countryStats.total_teachers;
                                partner.total_students = countryStats.total_students;
                                partner.total_others = countryStats.total_others;
                            }
                            }

                             if (partner.metrics) {
                                partner.total_teachers = partner.metrics.total_teachers
                                            ? partner.metrics.total_teachers : partner.total_teachers;
                                partner.total_students = partner.metrics.total_students
                                            ? partner.metrics.total_students : partner.total_students;
                            }
                        });

                        // sortByProperty(partners, 'total_users', 'DESC');
                        this.partners = partners;
                });
            });
        }
    }



    private getFirstCountryFromIndex(countries: CountryModel[]): string {
        const country: CountryModel = countries[0];
        return country ? country.name : '';
    }

    private numberFormatWithTextSuffix(value: number) {
        return numberFormatWithTextSuffix(value);
    }

    private getTagName(tags: any) {
        let tagName = '';
        if (tags && Object.keys(tags)) {
          Object.keys(tags).forEach((tag: any) => {
            tagName += tags[tag].toString();
          });
        }
        return tagName;
      }

}
